import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import MapChart from "../components/MapsChart";
import { useState } from "react";
import DotLoader from "react-spinners/DotLoader";

function ContactPage({ theme }) {
  let [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#ffffff");
  let [backgroundColor, setBackgroundColor] = useState("rgb(0,0,0,0.6)");
  const form = useRef();

  const reset = () => {
    document.getElementById("myForm").reset();
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    setColor(theme === "light" ? "#000000" : "#ffffff");
    setBackgroundColor(theme === "light" ? "rgb(0,0,0,0.6)" : "rgb(1,1,1,0.6)");
    emailjs
      .sendForm(
        "service_whv6r8k",
        "template_zh89tvb",
        form.current,
        "zoNUkvj5oa4THch63"
      )
      .then(
        (result) => {
          emailjs
            .sendForm(
              "service_whv6r8k",
              "template_t7c9onq",
              form.current,
              "zoNUkvj5oa4THch63"
            )
            .then(
              (result) => {
                setLoading(false);
                alert("Success send Message!");
                reset();
              },
              (error) => {
                setLoading(false);
                alert("Error - ", error);
                reset();
              }
            );
        },
        (error) => {
          setLoading(false);
          alert("Error - ", error);
          reset();
        }
      );
  };

  return (
    <>
      <div
        style={
          loading === false
            ? {
                display: "none",
              }
            : {
                width: "100%",
                height: "100%",
                margin: "auto",
                display: "flex",
                justifyContent: "center",
                backgroundColor: backgroundColor,
                zIndex: "99",
                position: "fixed",
              }
        }>
        <DotLoader
          color={color}
          loading={loading}
          cssOverride={{
            margin: "auto",
          }}
          size={50}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </div>

      <div className="tokyo_tm_section">
        <div
          data-aos="fade-right"
          data-aos-duration="1200"
          className="aos-init aos-animate">
          <div className="container">
            <div className="tokyo_tm_contact">
              <div className="tokyo_tm_title">
                <div className="title_flex">
                  <div className="left">
                    <span>Contact</span>
                    <h3>Get in Touch</h3>
                  </div>
                </div>
              </div>
              <div className="map_wrap">
                <div className="map">
                  <MapChart theme={theme} />
                </div>
              </div>
              <div className="fields">
                <form
                  className="contact_form"
                  id="myForm"
                  onSubmit={sendEmail}
                  ref={form}>
                  <div className="first">
                    <ul>
                      <li>
                        <input
                          type="text"
                          name="to_name"
                          placeholder="Name"
                          required=""
                        />
                      </li>
                      <li>
                        <input
                          type="email"
                          name="reply_to"
                          placeholder="Email"
                          required=""
                        />
                      </li>
                      <li>
                        <textarea
                          name="message"
                          placeholder="Message"
                          required=""></textarea>
                      </li>
                    </ul>
                  </div>
                  <div className="tokyo_tm_button">
                    <button type="submit" className="ib-button">
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactPage;
